import PropTypes from 'prop-types';

export default PropTypes.shape({
  writeData: PropTypes.func,
  cache: PropTypes.shape({
    writeData: PropTypes.func
  }),
  query: PropTypes.func
});
